/**
 * Define image slide contents mixin
 *
 * @author minkyoung.park@emcast.com
 */
//  check screen mode
function isPortrait() {
    if (screen.orientation === undefined) {
        return window.orientation === 0 || window.orientation === 180;
    } else {
        return screen.orientation.angle === 0;
    }
}

export const slideTypeMixins = {
    
    data() {
        return {

            isFirstScreenVisible: true,
            isLiked: false,
            isBookmarked: false,
            isPortrait: isPortrait(),
            mainTransitionName: 'fade',
            isQuestionAns:false,
            isLearningObjective:false,
            isResources:false,
            isNextLession:false,
            isQuizVisible: false,
            isResourceVisible: false,
            isQuizContainerVisible: false,
        }
    },

    watch: {
        'isAllPages' (){
            if (this.isAllPages) {
                this.$nextTick(function() {
                    this.moveScrollVerticalList(this.currentSlide-1)
                })
            }
        },
    },
    
    mounted() {
        

        // this.imagesContainer = document.querySelector('#videoContainer > div:first-child');
        // this.playlistContainer = document.getElementById('playlistContainer');
        // this.btnClose = document.getElementById('btnClose');
        // this.btnPlaylistClose = document.getElementById('btnPlaylistClose');
        // this.btnPlaylistToggle = document.getElementById('btnPlaylistToggle');

        // this.btnClose.addEventListener('click', () => {
        //     const body = document.getElementsByTagName('body')[0];
        //     if (body.classList.contains('overlay')) {
        //         body.classList.remove('overlay');
        //     }
        // });        

        
    },
    methods: {
        setisQuestionAns(){
            this.isQuestionAns = !this.isQuestionAns;
             this.isLearningObjective = false;
             this.isResources = false;
        },
        setisLearningObjective(){
            this.isResources = false;
            this.isQuestionAns = false;
            this.isLearningObjective = !this.isLearningObjective;
        },
        setisResources(){
            this.isLearningObjective = false;
            this.isQuestionAns = false;
            this.isResources = !this.isResources;
        },
        setisNextLession(){
            this.isNextLession = !this.isNextLession;
            this.closeNav();
        },
        closeAllSidebar(){
            this.isQuestionAns = false;
            this.isLearningObjective= false;
            this.isResources= false;
            this.isNextLession= false;
        },
        closeNav() {
            document.getElementById("gallery-thumbs-container").style.marginRight = "-300px";
            document.querySelector('.slide-slider').classList.remove("indexed")
        },
        onScrollClick: function () {
            this.isScroll = !this.isScroll
           
            setTimeout(() => {
                if (this.imagesContainer.parentNode.classList.contains('scroll')) {
                   // this.imagesContainer.parentNode.classList.add('paging');
                   // this.imagesContainer.parentNode.classList.remove('scroll');
                    

                    const element = document.getElementById('pagingIcon');
                    element.classList.add('fade', 'show');
                    setTimeout(() => {
                        element.classList.add('hide');
                        setTimeout(() => {
                            element.classList.remove('fade', 'show', 'hide');
                        }, 300);
                    }, 1000 + 300);
                } else {
                    //this.imagesContainer.parentNode.classList.add('scroll');
                    //this.imagesContainer.parentNode.classList.remove('paging');

                    const element = document.getElementById('scrollIcon');
                    element.classList.add('fade', 'show');
                    setTimeout(() => {
                        element.classList.add('hide');
                        setTimeout(() => {
                            element.classList.remove('fade', 'show', 'hide');
                        }, 300);
                    }, 1000 + 300);
                }

               document.querySelector('#videoContainer > div:first-child').classList.remove('hide');
            }, 500);
        },

    async openQuizDetail() {
        this.closeResourcePopUp();
        const elementBody = document.querySelector('body');
        elementBody.classList.add('quiz-overlay');
        this.mainTransitionName = 'slide-up';
        this.isTimelineQuiz = false;
        this.isQuizVisible = true;
        this.isTimeline = true;
      },
  
      closeQuizDetail() {
        return new Promise(resolve => {
            const elementBody = document.querySelector('body');
            this.mainTransitionName = 'slide-up';
            this.isQuizVisible = false;

            setTimeout(() => {
                elementBody.classList.remove('quiz-overlay');
                this.isTimeline = false;
                resolve();
            }, 500)
        })
      },
  
      async openResource() {
        await this.closeQuizDetail()
        const elementBody = document.querySelector('body');
        elementBody.classList.add('quiz-overlay');
        this.mainTransitionName = 'slide-up';
        this.isTimelineResource = true;
        this.isTimeline = true;
      },
  
      // 타임라인 퀴즈 상세 닫기(close detailed timeline resource)
      closeResourcePopup() {
        this.isTimelineResource = false;
      },
    }
}